<template>
    <div class="layout-content" :noCardStyle="noCardStyle">
        <b-card>
            <slot />
        </b-card>
    </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'

export default {
    components: { BCard },
    props: {
        noCardStyle: { type: Boolean, default: false }
    },
    data: () => ({
    })
}
</script>

<style scoped>
.layout-content + .layout-content {
    margin-top: 1rem;
}

.layout-content[noCardStyle] > .card > .card-body {
    padding: 0;
    background: none;
}

.layout-content[noCardStyle] > .card {
    border: none;
    background: none;
}
</style>
